import Factory from './utils/factory'

export default Factory({
  name: null,
  organizationNumber: null,
  logo: null,
  logoInverted: null
})
